import {unaVez} from "../eventos";

const acordeon = (selector: string, unico: boolean = true) => {
    [].forEach.call(document.querySelectorAll(selector), (contenedor: HTMLDivElement) => {
        const botones: HTMLButtonElement[] = [].slice.call(contenedor.querySelectorAll<HTMLButtonElement>('[aria-controls]')),
            paneles: HTMLElement[] = botones.map(boton => document.getElementById(boton.getAttribute('aria-controls')!)!);

        let abriendo = false;

        paneles.forEach(panel => panel.style.maxHeight = '0px');

        const mostrar = (panel: HTMLElement): Promise<void> => {
            return new Promise(resolve => {
                panel.hidden = false;
                panel.setAttribute('aria-expanded', 'true');
                botones
                    .filter(x => x.getAttribute('aria-controls') === panel.id)
                    .forEach(x => x.setAttribute('aria-expanded', 'true'));

                panel.closest('div')!.classList.add('activo');

                panel.style.maxHeight = '0px';

                requestAnimationFrame(() => {
                    panel.style.maxHeight = panel.scrollHeight + 'px';

                    unaVez(panel, 'transitionend', () => {
                        panel.style.maxHeight = 'initial';
                        resolve();
                    });
                });
            });
        };

        const ocultar = (panel: HTMLElement): Promise<void> => {
            return new Promise(resolve => {
                panel.setAttribute('aria-expanded', 'false');
                botones
                    .filter(x => x.getAttribute('aria-controls') === panel.id)
                    .forEach(x => x.setAttribute('aria-expanded', 'false'));

                panel.closest('div')!.classList.remove('activo');

                requestAnimationFrame(() => {
                    panel.style.maxHeight = panel.scrollHeight + 'px';

                    requestAnimationFrame(() => {
                        panel.style.maxHeight = '0px';

                        unaVez(panel, 'transitionend', () => {
                            panel.hidden = true;
                            resolve();
                        });
                    });
                });
            });
        }

        const abrePanel = (posicion: number) => {
            if (abriendo) {
                return;
            }

            if (posicion >= 0) {
                abriendo = true;

                let promesas: Promise<void>[] = [];

                if (paneles[posicion].hidden) {
                    promesas.push(mostrar(paneles[posicion]));
                } else {
                    promesas.push(ocultar(paneles[posicion]));
                }

                if (unico) {
                    paneles
                        .filter((panel, i) => i !== posicion && !panel.hidden)
                        .forEach(panel => promesas.push(ocultar(panel)));
                }

                Promise.all(promesas).then(() => abriendo = false);
            }
        }

        contenedor.addEventListener('click', e => {
            const target = e.target as HTMLElement;
            const boton = target.closest<HTMLButtonElement>('button');

            if (boton) {
                abrePanel(botones.indexOf(boton));
            }
        }, true);

        contenedor.addEventListener('keydown', e => {
            const target = e.target as HTMLElement;
            const boton = target.closest<HTMLButtonElement>('button');

            if (!boton) {
                return;
            }

            switch (e.key) {
                case 'Space': {
                    abrePanel(botones.indexOf(boton));
                    break;
                }
                case 'ArrowDown': {
                    const siguiente = (botones.indexOf(boton) + 1) % botones.length;
                    botones[siguiente].focus();
                    e.preventDefault();
                    break;
                }
                case 'ArrowUp': {
                    const posicion = botones.indexOf(boton),
                        siguiente = posicion === 0 ? botones.length - 1 : posicion - 1;
                    botones[siguiente].focus();
                    e.preventDefault();
                    break;
                }
                case 'Home': {
                    botones[0].focus();
                    e.preventDefault();
                    break;
                }
                case 'End': {
                    botones[botones.length - 1].focus();
                    e.preventDefault();
                    break;
                }
            }
        }, true);
    });
}

export default acordeon;